import { apiClient } from './client';
import type { EinheitListItem } from '../types';
import type { PaginatedResponse } from '../types/api';

export interface EinheitenQueryParams {
  page?: number;
  per_page?: number;
  search_text?: string;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
  include_hidden?: boolean;
}

export type EinheitListResponse = PaginatedResponse<EinheitListItem>;

export interface EinheitUpdateData {
  bezeichnung?: string;
  typ?: string | null;
  guests_count?: number | null;
  bedrooms?: number | null;
  size_sqm?: number | null;
  registrierungsnummer?: string | null;
  notes?: string | null;
}

export interface EinheitDetail {
  id: number;
  user_id: number;
  haus_id: number;
  parent_id: number | null;
  bezeichnung: string;
  typ: string | null;
  guests_count: number | null;
  bedrooms: number | null;
  size_sqm: number | null;
  registrierungsnummer: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
}

export const einheitenApi = {
  getEinheiten: async (params: EinheitenQueryParams = {}): Promise<EinheitListResponse> => {
    const { data } = await apiClient.get('/einheiten/', { params });
    return data;
  },

  getEinheit: async (id: number): Promise<EinheitDetail> => {
    const { data } = await apiClient.get(`/einheiten/${id}`);
    return data;
  },

  updateEinheit: async (id: number, updates: EinheitUpdateData): Promise<EinheitDetail> => {
    const { data } = await apiClient.patch(`/einheiten/${id}`, updates);
    return data;
  },

  createEinheit: async (body: {
    haus_id: number;
    bezeichnung: string;
    typ?: string;
    guests_count?: number;
    bedrooms?: number;
    size_sqm?: number;
    registrierungsnummer?: string;
    notes?: string;
  }): Promise<EinheitDetail> => {
    const { data } = await apiClient.post('/einheiten/', body);
    return data;
  },

  deleteEinheit: async (id: number): Promise<void> => {
    await apiClient.delete(`/einheiten/${id}`);
  },
};
